var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.433,
    height: 22.436,
    viewBox: "0 0 22.433 22.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    "data-name": "search icon",
    transform: "translate(-403.787 -549.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-search",
    "data-name": "Icon awesome-search",
    d: "M22.128,19.4l-4.369-4.369a1.051,1.051,0,0,0-.745-.307H16.3A9.11,9.11,0,1,0,14.722,16.3v.714a1.051,1.051,0,0,0,.307.745L19.4,22.128a1.047,1.047,0,0,0,1.485,0l1.24-1.24a1.057,1.057,0,0,0,0-1.49ZM9.114,14.722a5.609,5.609,0,1,1,5.609-5.609A5.605,5.605,0,0,1,9.114,14.722Z",
    transform: "translate(403.787 549.686)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-minus",
    "data-name": "Icon awesome-minus",
    d: "M6.209,14.625H.478c-.264,0-.478.359-.478.8v.8c0,.443.214.8.478.8H6.209c.264,0,.478-.359.478-.8v-.8C6.686,14.984,6.472,14.625,6.209,14.625Z",
    transform: "translate(5.732 -6.439)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomMinus);
export default __webpack_public_path__ + "static/media/zoom_minus.bc22607403e0bebe8d78778795f65a75.svg";
export { ForwardRef as ReactComponent };